module.exports = __webpack_public_path__ + "img/ok_icon.a6bf112b.svg";